import { render, staticRenderFns } from "./ShopBrowser.vue?vue&type=template&id=1b868caa&"
import script from "./ShopBrowser.vue?vue&type=script&lang=ts&"
export * from "./ShopBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/BUILD/Desktop/vsts-agent-win-x64-2.131.0/_work/13/s/DiapasonWeb/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDivider,VFlex,VHover,VIcon,VLayout,VList,VListTile,VListTileTitle,VPagination,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep,VSubheader,VTextField})
